import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

function UserChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const getToken = () => {
    try {
      const raw = localStorage.getItem("state");
      if (raw) {
        const state = JSON.parse(raw);
        return state.auth?.token;
      }
    } catch (e) {
      console.error("Token parsing failed", e);
    }
    return null;
  };

  const submit = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      Swal.fire({ title: "Error", text: "Passwords do not match.", icon: "error", confirmButtonText: "Ok" });
      return;
    }
    setLoading(true);
    const token = getToken();
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AppUser/ChangePassword`,
        { CurrentPassword: currentPassword, NewPassword: newPassword },
        { headers: { ...(token && { Authorization: `Bearer ${token}` }) } }
      )
      .then(() => {
        Swal.fire({ title: "Success", text: "Password changed.", icon: "success", confirmButtonText: "Ok" });
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err.response?.data || "Could not change password.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="page-content-wrapper">
      <div className="page-content">
        <div className="page-bar">
          <div className="page-title-breadcrumb">
            <div className="pull-left">
              <div className="page-title">Change Password</div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="card card-box">
              <div className="card-body">
                <form onSubmit={submit}>
                  <div className="form-group mb-3">
                    <label className="control-label">Current Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label className="control-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label className="control-label">Confirm New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Saving..." : "Change Password"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserChangePassword;